<template>
  <div class="home">
    <loading :active.sync="loading"
             :can-cancel="true"
             :is-full-page="true"></loading>
    <!-- <b-alert v-if="userInfo"
             key="modal-qrcode"
             v-model="showMobileAppAlert"
             variant="success"
             :style="{textAlign:isWebsite?'center':''}"
             dismissible>
      {{ $t('home.downloadAlert') }}
      <a href="#"
         class="a-login"
         v-b-modal.modal-qrcode> {{ $t('home.here') }} </a>.
    </b-alert>
    <b-alert v-else
             key="modal-login"
             v-model="showLoginAlert"
             class="alert"
             :style="{textAlign:isWebsite?'center':''}"
             dismissible>
      {{ $t('home.notLoggedIn') }}
      <a href="#"
         class="a-login"
         v-b-modal.modal-login> {{ $t('home.login') }} </a>
      {{ $t('home.expMore') }}
    </b-alert>-->
    <div class="mobile_login"
         v-show="isShowLogin || !isHome">
      <div class="skip"
           @click="$route.query.from  ? $router.push('/') : $router.go(-1)">
        <div class="sikp_btn">{{$t('home.skip')}}</div>
      </div>
      <!-- <div class="login_logo">
          <img src="/static/newVersionImgs/logo.png">
      </div>-->
      <div class="text-center"
           v-if="isMobileApp">
        <img
          class="social-login-icon"
          @click="wechatMobileLogin()"
          src="static/images/wechat-logo.png"
        >
        <img
          class="social-login-icon"
          @click="login('twitter')"
          src="static/images/twitter-logo.jpeg"
        >
        <img class="social-login-icon"
             @click="lineMobileLogin()"
             src="static/images/line-logo.png" >
        <img
          class="social-login-icon"
          @click="fbMobileLogin()"
          src="static/images/facebook-logo.png"
        >
      </div>
      <div class="login_icon"
           v-if="isWebsite">
        <img src="/static/newVersionImgs/login_top.svg"
             class="login_logo"
             alt >
        <div class="login_line"
             style="margin-top:100px"
             @click="login('twitter')">
          <img src="../../static/images/twitter-logo.jpeg"
               alt >
          <div class="line_text">{{$t('newTextForm.twiLogin')}}</div>
          <div></div>
        </div>
        <div class="login_line"
             @click="login('facebook')">
          <img src="../../static/images/facebook-logo.png"
               alt >
          <div class="line_text">{{$t('newTextForm.facebookLogin')}}</div>
          <div></div>
        </div>
        <div class="login_line"
             @click="login('wechat')">
          <img src="../../static/images/wechat-logo.png"
               alt >
          <div class="line_text">{{$t('newTextForm.wechatLogin')}}</div>
          <div></div>
        </div>
        <div class="login_line"
             @click="login('line')">
          <img src="../../static/images/line-logo.png"
               alt >
          <div class="line_text">{{$t('newTextForm.lineLogin')}}</div>
          <div></div>
        </div>
        <div class="bottom_div"></div>
      </div>
    </div>
    <b-modal id="modal-qrcode"
             :title="$t('home.downloadTitle')"
             ok-only>
      <div class="text-center">
        <div>{{ $t('home.scanQRCode') }}</div>
        <img width="180"
             src="/static/images/petal_google_play.png" >
        <img width="200"
             src="/static/images/android_qrcode.svg" >
        <div>
          {{ $t('home.downloadFrom') }}
          <a
            href="https://play.google.com/store/apps/details?id=network.petal.sharing"
          >Google Play</a>
          , {{ $t('home.orClick') }}
          <a
            href="https://download.petal.social/petal_latest.apk"
          >{{ $t('home.here') }}</a>
          {{ $t('home.downloadDirectly') }}
        </div>
      </div>
    </b-modal>
    <b-modal
      id="modal-login"
      ref="loginModal"
      :title="$t('home.login')"
      ok-only
      hide-footer
      hide-header
    >
      <div class="text-center"
           v-if="isMobileApp">
        <img
          class="social-login-icon"
          @click="wechatMobileLogin()"
          src="static/images/wechat-logo.png"
        >
        <img
          class="social-login-icon"
          @click="login('twitter')"
          src="static/images/twitter-logo.jpeg"
        >
        <img class="social-login-icon"
             @click="lineMobileLogin()"
             src="static/images/line-logo.png" >
        <img
          class="social-login-icon"
          @click="fbMobileLogin()"
          src="static/images/facebook-logo.png"
        >
      </div>
      <div class="login_icon"
           v-if="isWebsite">
        <!-- <div class="text-center">
          <img class="social-login-icon"
               @click="login('line')"
               src="/static/images/line-logo.png">
          <img class="social-login-icon"
               @click="login('facebook')"
               src="/static/images/facebook-logo.png">
        </div>
        <div class="text-center margin-top">
          <img class="social-login-icon"
               @click="login('twitter')"
               src="/static/images/twitter-logo.jpeg">
          <img class="social-login-icon"
               @click="login('wechat')"
               src="/static/images/wechat-logo.png">
        </div>-->
        <img src="../../static/newVersionImgs/login_top.svg"
             class="top_logo"
             alt >
        <div class="close_btn"
             @click="closeLogin()">x</div>
        <div class="login_text">
          <div class="top_line"></div>
          {{$t('home.login')}}
          <div class="top_line"></div>
        </div>
        <div class="login_line"
             @click="login('twitter')">
          <img src="../../static/images/twitter-logo.jpeg"
               alt >
          <div class="line_text">{{$t('newTextForm.twiLogin')}}</div>
          <div></div>
        </div>
        <div class="login_line"
             @click="login('facebook')">
          <img src="../../static/images/facebook-logo.png"
               alt >
          <div class="line_text">{{$t('newTextForm.facebookLogin')}}</div>
          <div></div>
        </div>
        <div class="login_line"
             @click="login('wechat')">
          <img src="../../static/images/wechat-logo.png"
               alt >
          <div class="line_text">{{$t('newTextForm.wechatLogin')}}</div>
          <div></div>
        </div>
        <div class="login_line"
             @click="login('line')">
          <img src="../../static/images/line-logo.png"
               alt >
          <div class="line_text">{{$t('newTextForm.lineLogin')}}</div>
          <div></div>
        </div>
        <div class="bottom_div">
          <!-- {{$t('newTextForm.loginBottomText')}}
          <a href="javascript:void(0)">{{$t('newTextForm.userXieyi')}}</a>
          {{$t('newTextForm.and')}}<a href="javascript:void(0)">{{$t('newTextForm.yinsiXieyi')}}</a>-->
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
import Loading from 'vue-loading-overlay'
import 'vue-loading-overlay/dist/vue-loading.css'
import { mapGetters, mapActions } from 'vuex'
import { isLocalTokenValid } from '@/utils/common'
import {
    getUserInfo,
    getBaseUrl,
    facebookUserLogin,
    lineUserLogin,
    wechatUserLogin
} from '@/utils/api'
import { LINE_CHANNEL } from '@/constants'

export default {
    data() {
        return {
            isMobileApp: process.env.PLATFORM === 'mobile_app',
            isWebsite: process.env.PLATFORM === 'website',
            showMobileAppAlert: process.env.PLATFORM !== 'mobile_app',
            showLoginAlert: true,
            showQRCode: false,
            loading: false,
            isShowLogin: false
        }
    },
    created() {
        this.checkLogin()
        this.isShowLogin = !!this.$route.query.login
    },
    props: {
        isHome: {
            default: true,
            type: Boolean
        }
    },
    methods: {
        ...mapActions([
            'setUserInfo',
            'setUserBalance',
            'addActivePoint',
            'setActivePoint',
            'setSharedVideoCount'
        ]),
        checkLogin() {
            setInterval(() => {
                let isLogin = isLocalTokenValid()
                if (isLogin && !this.userInfo && !this.loading) {
                    this.loading = true
                    getUserInfo()
                        .then(res => {
                            this.setUserInfo(res.data)
                            let lastUserId = localStorage.getItem('last_user_id')
                            if (
                                lastUserId &&
                this.$store.state.userInfo.id === parseInt(lastUserId)
                            ) {
                                this.addActivePoint(0.0001)
                            } else {
                                localStorage.setItem(
                                    'last_user_id',
                                    this.$store.state.userInfo.id
                                )
                                this.setSharedVideoCount(0)
                                this.setActivePoint(0.0001)
                            }
                            localStorage.removeItem('referrer_code')
                            this.loading = false
                        })
                        .catch(error => {
                            this.loading = false
                            if (error.response.status === 404 || error.response.status === 500) {
                                this.$router.push('/logout')
                            }
                        })
                }
            }, 1000)
        },
        isPC() {
            let ua = navigator.userAgent
            let agents = [
                'Android',
                'iPhone',
                'SymbianOS',
                'Windows Phone',
                'iPad',
                'iPod'
            ]
            for (let v = 0; v < agents.length; v++) {
                if (ua.indexOf(agents[v]) > 0) {
                    return false
                }
            }
            return true
        },
        isWechat() {
            let ua = navigator.userAgent
            return ua.indexOf('MicroMessenger') > 0
        },
        login(socialApp) {
            let referrerCode = localStorage.getItem('referrer_code')
            if (this.isMobileApp) {
                let url =
          getBaseUrl() + '/oauth/' + socialApp + '/login?from_mobile_app=true'
                if (referrerCode) {
                    url += '&code=' + referrerCode
                }
                window.open(url, '_system')
            } else {
                if (socialApp === 'wechat') {
                    if (!this.isPC()) {
                        if (this.isWechat()) {
                            let url =
                getBaseUrl() +
                '/oauth/' +
                socialApp +
                '/login?from_wechat_web=true'
                            if (referrerCode) {
                                url += '&code=' + referrerCode
                            }
                            window.location = url
                            return
                        } else {
                            alert(this.$t('account.wechatLoginPrompt'))
                            return
                        }
                    }
                }
                let url = getBaseUrl() + '/oauth/' + socialApp + '/login'
                if (referrerCode) {
                    url += '?code=' + referrerCode
                }
                window.location = url
            }
        },
        fbMobileLogin() {
            if (!this.isMobileApp || typeof facebookConnectPlugin === 'undefined') {
                return
            }
            this.$refs.loginModal.hide()
            /* global facebookConnectPlugin:true */
            /* eslint no-undef: "error" */
            facebookConnectPlugin.login(
                ['public_profile'],
                res => {
                    if (
                        res.hasOwnProperty('authResponse') &&
            res['authResponse'].hasOwnProperty('accessToken')
                    ) {
                        let accessToken = res['authResponse']['accessToken']
                        facebookUserLogin(accessToken).then(res => {
                            if (res.data.status === 'ok') {
                                localStorage.setItem('user_token', res.data.token)
                                localStorage.setItem('user_token_ts', new Date().getTime())
                            } else {
                                alert(this.$t('account.facebookLoginFailed'))
                            }
                        })
                    }
                },
                error => {
                    alert(this.$t('account.facebookLoginFailed'))
                    console.error(error)
                }
            )
        },
        wechatMobileLogin() {
            if (!this.isMobileApp || typeof Wechat === 'undefined') {
                return
            }
            this.$refs.loginModal.hide()
            /* global Wechat:true */
            /* eslint no-undef: "error" */
            Wechat.isInstalled(
                isInstalled => {
                    if (!isInstalled) {
                        alert(this.$t('account.wechatNotInstalled'))
                    } else {
                        var scope = 'snsapi_userinfo'
                        var state = '_' + +new Date()
                        Wechat.auth(
                            scope,
                            state,
                            function(response) {
                                let accessToken = response.code
                                console.log(accessToken)
                                wechatUserLogin(accessToken).then(
                                    res => {
                                        if (res.data.status === 'ok') {
                                            localStorage.setItem('user_token', res.data.token)
                                            localStorage.setItem(
                                                'user_token_ts',
                                                new Date().getTime()
                                            )
                                        } else {
                                            alert(this.$t('account.wechatLoginFailed'))
                                        }
                                    },
                                    error => {
                                        console.error(error)
                                    }
                                )
                            },
                            function(reason) {
                                alert('Failed: ' + reason)
                            }
                        )
                    }
                },
                error => {
                    alert(this.$t('account.wechatLoginFailed'))
                    console.error(error)
                }
            )
        },
        lineMobileLogin() {
            if (!this.isMobileApp || typeof lineLogin === 'undefined') {
                return
            }
            this.$refs.loginModal.hide()
            /* global lineLogin:true */
            /* eslint no-undef: "error" */
            lineLogin.initialize({ channel_id: LINE_CHANNEL })
            lineLogin.login(
                result => {
                    lineLogin.getAccessToken(
                        tokenRes => {
                            lineUserLogin(tokenRes['accessToken']).then(res => {
                                if (res.data.status === 'ok') {
                                    localStorage.setItem('user_token', res.data.token)
                                    localStorage.setItem('user_token_ts', new Date().getTime())
                                } else {
                                    alert(this.$t('account.facebookLoginFailed'))
                                }
                            })
                        },
                        error => {
                            alert(this.$t('account.getAccessTokenFailed'))
                            console.error(error)
                        }
                    )
                },
                error => {
                    alert(this.$t('account.lineLoginFailed'))
                    console.error(error)
                }
            )
        },
        closeLogin() {
            this.$refs.loginModal.hide()
        }
    },
    computed: {
        ...mapGetters(['userInfo', 'userBalance', 'currentVideo', 'activePoint'])
    },
    components: {
        Loading
    }
}
</script>
<style lang="scss" scoped>
.login_icon {
  display: flex;
  flex-direction: column;
  align-items: center;
  .top_logo {
    width: 64px;
    height: 77px;
    margin-top: 40px;
  }
  .close_btn {
    position: absolute;
    top: 0;
    right: 20px;
    font-size: 30px;
    font-weight: 200;
    width: 30px;
    text-align: right;
    cursor: pointer;
  }
  .login_text {
    display: flex;
    align-items: center;
    width: 300px;
    margin: 25px 0;
    white-space: nowrap;
    .top_line {
      border-top: 1px solid black;
      width: 100px;
      margin: 0 20px;
    }
  }
  .login_line {
    cursor: pointer;
    display: flex;
    justify-content: space-around;
    align-items: center;
    border: 1px solid #e5e5e5;
    width: 350px;
    margin: 10px 0;
    height: 55px;
    border-radius: 10px;
    img {
      width: 40px;
      height: 40px;
    }
    .line_text {
      width: 150px;
      text-align: center;
    }
  }
  .bottom_div {
    text-align: center;
    width: 60%;
    margin: 50px 0;
    color: #7f7f7f;
    a {
      color: black;
      text-decoration: underline;
    }
  }
}
.margin-top {
  margin-top: 40px;
}
.tab-content {
  margin: 40px 5px;
}
.language-btn {
  float: right;
  margin-right: 10px;
}
.alert {
  color: #ffffff;
  font-size: 23px;
  background: #fe4987;
  text-align: left;
}
.a-login {
  display: inline-block;
  padding: 0px 5px;
  border-radius: 5px;
  text-decoration: none;
  text-align: center;
  background-color: #ffffff;
  color: #4a90e2;
}
.social-login-icon {
  width: 90px;
  height: 90px;
  margin-left: 40px;
  margin-right: 40px;
}
.hide {
  display: none;
}
>>> .modal-header .close {
  outline: 0;
  position: relative;
  top: 15px;
  right: 10px;
  font-size: 30px;
  width: 35px;
  height: 35px;
  padding: 0px 0px 5px 0px;
  color: #ffffff;
  background: #000000 !important;
  opacity: 1;
  border-radius: 17px;
}
>>> .modal-header {
  border-bottom: 0;
  padding-bottom: 0;
}
>>> .modal-footer {
  padding-top: 0;
  padding-bottom: 1rem;
  justify-content: center;
  border-top: none;
}
>>> .modal-content {
  background: #ffffff;
  border-radius: 26px;
  width: 560px;
}
>>> .modal-footer .btn-primary {
  font-size: 20px;
  width: 100px;
  height: 40px;
  background-color: #000000;
}
>>> .modal-body {
  padding-top: 30px;
  padding-bottom: 40px;
}
>>> .modal-title {
  width: 70%;
  left: 15%;
  border-bottom: 2px solid #000000;
  text-align: center;
  font-weight: 500;
  font-size: 30px;
  position: relative;
  line-height: 1.5;
  padding-bottom: 4px;
}
@media only screen and (max-width: 768px) {
  >>> .modal-content {
    margin-top: 50%;
    width: 100%;
  }
  >>> .modal-title {
    border-bottom: none;
  }
  .social-login-icon {
    width: 70px;
    height: 70px;
    margin: 12px 28px;
  }
  .login_icon {
    text-align: center;
    .login_logo {
      margin-top: 80px;
      width: 96px;
      height: 115px;
    }
  }
  .margin-top {
    margin-top: 0;
  }
  .alert {
    font-size: 17px;
  }

  .home {
    display: flex;
    flex-direction: column;
    align-items: center;

    .mobile_login {
      width: 100%;
      background-color: #fff;

      .skip {
        width: 95%;
        display: flex;
        justify-content: flex-end;
        margin-top: 20px;

        .sikp_btn {
          width: 60px;
          height: 32px;
          text-align: center;
          line-height: 32px;
          border-radius: 36px;
          color: #000;
          font-size: 14px;
          box-shadow: 0 10px 20px 0 rgba($color: #000000, $alpha: 0.1);
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/TopAlert.vue